import React, { useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import SliceStep2 from './SliceStep2';
import './DashboardWheel.css';
import ModalOolaWheel from '../ModalOolaWheel/ModalOolaWheel';
import svgWheel from '../../../../Assets/icons/iconShareWheel.svg';

const Wheel = (propsx) => {
    const [showPop, setShowPop] = useState(propsx.showColors==true?true:false);
    const [showModalWheel, setShowModalWheel] = useState(false);

    const props = propsx;

    
    const SVGWheel = (
        <svg
            width="50"
            height="80"
            viewBox="0 0 725 755"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="BlueWheel"
        >
            <path
                d="M552.323 177.98L387.368 308.798C399.286 327.133 404.265 349.122 401.407 370.804L606.736 417.908C624.089 330.907 601.938 244.519 552.323 177.98Z"
                fill="#344A58"
            />
            <path
                d="M79.6147 164.508L244.186 295.808C259.371 280.07 279.676 270.273 301.445 268.18L301.153 57.5176C212.478 60.1796 133.287 101.196 79.6147 164.508Z"
                fill="#344A58"
            />
            <path
                d="M218.297 359.795C218.27 341.963 223.449 324.511 233.197 309.579L95.91 200.273C73.6924 230.082 57.9435 264.201 49.6713 300.447C41.3991 336.693 40.7858 374.267 47.871 410.764L219.056 371.656C218.551 367.723 218.297 363.761 218.297 359.795Z"
                fill="#344A58"
            />
            <path
                d="M310.34 557.032C337.016 557.059 363.418 551.643 387.93 541.117L342.207 446.172C321.652 453.723 299.084 453.73 278.525 446.192L232.856 541.166C257.339 551.661 283.702 557.059 310.34 557.032Z"
                fill="#344A58"
            />
            <path
                d="M704.239 457.986L397.957 388.208C391.1 408.873 377.119 426.427 358.512 437.733L495.055 720.546C597.958 667.892 675.53 572.524 704.239 457.986Z"
                fill="#344A58"
            />
            <path
                d="M319.693 24L319.744 268.36C341.423 270.408 361.655 280.14 376.786 295.8L567.599 143.381C507.726 72.4089 419.008 26.524 319.693 24Z"
                fill="#344A58"
            />
            <path
                d="M224.18 388.35L19.9995 435.209C30.7018 475.968 49.8161 514.036 76.1128 546.965C102.409 579.895 135.307 606.956 172.689 626.409L263.627 437.768C245.039 426.488 231.06 408.975 224.18 388.35Z"
                fill="#344A58"
            />
            <path
                d="M319.75 299.083C332.133 300.859 343.666 306.412 352.777 314.983L363.084 306.749C351.368 295.163 336.113 287.827 319.747 285.91L319.75 299.083Z"
                fill="#344A58"
            />
            <path
                d="M311.044 433.557C319.235 433.559 327.369 432.201 335.114 429.537L329.399 417.668C317.462 421.415 304.665 421.419 292.726 417.68L287.018 429.55C294.751 432.204 302.869 433.559 311.044 433.557Z"
                fill="#344A58"
            />
            <path
                d="M250.031 359.468C250.018 348.643 252.9 338.012 258.378 328.676L248.061 320.461C240.788 332.17 236.942 345.683 236.961 359.467C236.962 362.101 237.105 364.734 237.385 367.354L250.253 364.414C250.117 362.782 250.031 361.136 250.031 359.468Z"
                fill="#344A58"
            />
            <path
                d="M254.137 381.472L241.277 384.422C246.838 399.904 257.38 413.102 271.25 421.946L276.968 410.085C266.618 403.099 258.651 393.115 254.137 381.472Z"
                fill="#344A58"
            />
            <path
                d="M380.853 384.31L367.987 381.38C363.487 393.05 355.518 403.061 345.153 410.063L350.878 421.921C364.763 413.054 375.307 399.823 380.853 384.31Z"
                fill="#344A58"
            />
            <path
                d="M269.289 315.004C278.38 306.442 289.887 300.887 302.246 299.095L302.229 285.921C285.89 287.86 270.668 295.2 258.977 306.776L269.289 315.004Z"
                fill="#344A58"
            />
            <path
                d="M384.727 367.239C384.997 364.657 385.132 362.063 385.133 359.468C385.151 345.669 381.297 332.142 374.008 320.425L363.696 328.645C369.184 337.988 372.072 348.631 372.059 359.468C372.059 361.102 371.976 362.717 371.85 364.32L384.727 367.239Z"
                fill="#344A58"
            />

            <defs>
                <clipPath id="clip0">
                    <rect
                        width="89.2176"
                        height="102.57"
                        fill="white"
                        transform="translate(316.94 291) rotate(46.1267)"
                    />
                </clipPath>
            </defs>
            <g
                clipPath="url(#clip0)"
                transform="scale(3) translate(-200 -110)"
            >
                <path
                    d="M345.397 379.36L348.717 355.016C349.126 350.437 345.723 346.891 341.088 347.122C339.619 347.195 338.206 347.643 336.948 348.379C336.772 344.341 333.548 341.371 329.295 341.583C327.829 341.659 326.416 342.107 325.156 342.834C324.973 338.803 321.752 335.829 317.502 336.044C316.064 336.116 314.681 336.546 313.441 337.249L314.416 326.342C314.826 321.763 311.422 318.217 306.788 318.448C302.193 318.674 298.12 322.591 297.71 327.176L293.964 369.077L280.484 359.321C276.893 356.635 271.394 357.292 267.686 360.857C264.907 363.529 264.537 367.671 266.861 370.089L293.362 397.653C297.491 401.948 303.295 404.137 309.707 403.817L319.415 403.333C325.818 403.016 332.061 400.226 336.991 395.486C341.596 391.059 344.581 385.331 345.397 379.36ZM319.804 398.981L310.096 399.465C304.851 399.727 300.102 397.936 296.723 394.422L270.222 366.857C269.446 366.05 269.569 364.672 270.497 363.78C272.541 361.815 275.574 361.452 277.578 362.952L294.322 375.066C294.942 375.516 295.813 375.54 296.58 375.134C297.341 374.729 297.871 373.955 297.944 373.136L302.073 326.958C302.269 324.773 304.211 322.906 306.436 322.791C307.531 322.74 308.486 323.133 309.14 323.815C309.795 324.496 310.151 325.465 310.053 326.56L307.3 357.352C307.193 358.552 308.084 359.479 309.287 359.419C309.889 359.386 310.457 359.115 310.887 358.702C311.318 358.288 311.61 357.731 311.664 357.128L312.788 344.554C312.984 342.369 314.923 340.505 317.151 340.394C319.335 340.285 320.963 341.977 320.768 344.156L319.643 356.736C319.536 357.936 320.427 358.863 321.63 358.803C322.232 358.77 322.8 358.5 323.231 358.086C323.661 357.672 323.953 357.116 324.007 356.512L324.581 350.093C324.776 347.908 326.716 346.044 328.944 345.933C331.128 345.824 332.756 347.516 332.561 349.695L331.984 356.145C331.987 356.154 331.984 356.151 331.984 356.151L331.983 356.157C331.983 356.163 331.983 356.163 331.983 356.163C331.982 356.169 331.982 356.169 331.982 356.169L331.985 356.172C331.988 356.175 331.984 356.178 331.984 356.178C331.91 357.352 332.795 358.246 333.977 358.183C335.18 358.123 336.246 357.099 336.353 355.899L336.377 355.634C336.471 354.576 336.974 353.558 337.791 352.773C338.607 351.988 339.638 351.526 340.736 351.471C342.927 351.368 344.542 353.055 344.366 355.132L341.059 379.374C340.389 384.254 337.948 388.94 334.181 392.563C330.147 396.44 325.044 398.72 319.804 398.981Z"
                    fill="#344A58"
                />
                <path
                    d="M323.781 332.78C327.149 325.447 326.132 317.379 321.185 312.233C314.212 304.98 301.752 305.602 293.413 313.619C287.498 319.306 285.023 327.548 287.1 334.613C287.188 334.906 287.337 335.156 287.531 335.358C288.065 335.913 288.947 336.09 289.801 335.741C290.966 335.257 291.646 333.973 291.324 332.871C289.705 327.373 291.626 320.963 296.224 316.542C302.711 310.306 312.4 309.823 317.825 315.465C321.67 319.464 322.457 325.739 319.836 331.448C319.307 332.593 319.762 333.826 320.854 334.188C321.945 334.557 323.255 333.928 323.781 332.78Z"
                    fill="#344A58"
                />
            </g>
        </svg>
    );
    const SVGWheelColor=(          <svg
        width={propsx.showColors==true?"150":"50"}
        height={propsx.showColors==true?"150":"80"}
        viewBox={propsx.showColors==true?"0 0 1025 1025":"0 0 725 755"}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="BlueWheel"
    >
        <path
            d="M319.693 24L319.744 268.36C341.423 270.408 361.655 280.14 376.786 295.8L567.599 143.381C507.726 72.4089 419.008 26.524 319.693 24Z"
            fill="#15C184"
        />
        <path
            d="M552.323 177.98L387.368 308.798C399.286 327.133 404.265 349.122 401.407 370.804L606.736 417.908C624.089 330.907 601.938 244.519 552.323 177.98Z"
            fill="#9AC864"
        />
         <path
            d="M704.239 457.986L397.957 388.208C391.1 408.873 377.119 426.427 358.512 437.733L495.055 720.546C597.958 667.892 675.53 572.524 704.239 457.986Z"
            fill="#FABE53"
        />
         <path
            d="M310.34 557.032C337.016 557.059 363.418 551.643 387.93 541.117L342.207 446.172C321.652 453.723 299.084 453.73 278.525 446.192L232.856 541.166C257.339 551.661 283.702 557.059 310.34 557.032Z"
            fill="#F16636"
        />
     
        
        <path
            d="M224.18 388.35L19.9995 435.209C30.7018 475.968 49.8161 514.036 76.1128 546.965C102.409 579.895 135.307 606.956 172.689 626.409L263.627 437.768C245.039 426.488 231.06 408.975 224.18 388.35Z"
            fill="#EB0F47"
        />
         <path
            d="M79.6147 164.508L244.186 295.808C259.371 280.07 279.676 270.273 301.445 268.18L301.153 57.5176C212.478 60.1796 133.287 101.196 79.6147 164.508Z"
            fill="#022B7A"
        />
       <path
            d="M218.297 359.795C218.27 341.963 223.449 324.511 233.197 309.579L95.91 200.273C73.6924 230.082 57.9435 264.201 49.6713 300.447C41.3991 336.693 40.7858 374.267 47.871 410.764L219.056 371.656C218.551 367.723 218.297 363.761 218.297 359.795Z"
            fill="#700460"
        />
        
       
        <path
            d="M319.75 299.083C332.133 300.859 343.666 306.412 352.777 314.983L363.084 306.749C351.368 295.163 336.113 287.827 319.747 285.91L319.75 299.083Z"
            fill="#344A58"
        />
        <path
            d="M311.044 433.557C319.235 433.559 327.369 432.201 335.114 429.537L329.399 417.668C317.462 421.415 304.665 421.419 292.726 417.68L287.018 429.55C294.751 432.204 302.869 433.559 311.044 433.557Z"
            fill="#344A58"
        />
        <path
            d="M250.031 359.468C250.018 348.643 252.9 338.012 258.378 328.676L248.061 320.461C240.788 332.17 236.942 345.683 236.961 359.467C236.962 362.101 237.105 364.734 237.385 367.354L250.253 364.414C250.117 362.782 250.031 361.136 250.031 359.468Z"
            fill="#344A58"
        />
        <path
            d="M254.137 381.472L241.277 384.422C246.838 399.904 257.38 413.102 271.25 421.946L276.968 410.085C266.618 403.099 258.651 393.115 254.137 381.472Z"
            fill="#344A58"
        />
        <path
            d="M380.853 384.31L367.987 381.38C363.487 393.05 355.518 403.061 345.153 410.063L350.878 421.921C364.763 413.054 375.307 399.823 380.853 384.31Z"
            fill="#344A58"
        />
        <path
            d="M269.289 315.004C278.38 306.442 289.887 300.887 302.246 299.095L302.229 285.921C285.89 287.86 270.668 295.2 258.977 306.776L269.289 315.004Z"
            fill="#344A58"
        />
        <path
            d="M384.727 367.239C384.997 364.657 385.132 362.063 385.133 359.468C385.151 345.669 381.297 332.142 374.008 320.425L363.696 328.645C369.184 337.988 372.072 348.631 372.059 359.468C372.059 361.102 371.976 362.717 371.85 364.32L384.727 367.239Z"
            fill="#344A58"
        />

        <defs>
            <clipPath id="clip0">
                <rect
                    width="89.2176"
                    height="102.57"
                    fill="white"
                    transform="translate(316.94 291) rotate(46.1267)"
                />
            </clipPath>
        </defs>
        <g
            clipPath="url(#clip0)"
            transform="scale(3) translate(-200 -110)"
        >
            <path
                d="M345.397 379.36L348.717 355.016C349.126 350.437 345.723 346.891 341.088 347.122C339.619 347.195 338.206 347.643 336.948 348.379C336.772 344.341 333.548 341.371 329.295 341.583C327.829 341.659 326.416 342.107 325.156 342.834C324.973 338.803 321.752 335.829 317.502 336.044C316.064 336.116 314.681 336.546 313.441 337.249L314.416 326.342C314.826 321.763 311.422 318.217 306.788 318.448C302.193 318.674 298.12 322.591 297.71 327.176L293.964 369.077L280.484 359.321C276.893 356.635 271.394 357.292 267.686 360.857C264.907 363.529 264.537 367.671 266.861 370.089L293.362 397.653C297.491 401.948 303.295 404.137 309.707 403.817L319.415 403.333C325.818 403.016 332.061 400.226 336.991 395.486C341.596 391.059 344.581 385.331 345.397 379.36ZM319.804 398.981L310.096 399.465C304.851 399.727 300.102 397.936 296.723 394.422L270.222 366.857C269.446 366.05 269.569 364.672 270.497 363.78C272.541 361.815 275.574 361.452 277.578 362.952L294.322 375.066C294.942 375.516 295.813 375.54 296.58 375.134C297.341 374.729 297.871 373.955 297.944 373.136L302.073 326.958C302.269 324.773 304.211 322.906 306.436 322.791C307.531 322.74 308.486 323.133 309.14 323.815C309.795 324.496 310.151 325.465 310.053 326.56L307.3 357.352C307.193 358.552 308.084 359.479 309.287 359.419C309.889 359.386 310.457 359.115 310.887 358.702C311.318 358.288 311.61 357.731 311.664 357.128L312.788 344.554C312.984 342.369 314.923 340.505 317.151 340.394C319.335 340.285 320.963 341.977 320.768 344.156L319.643 356.736C319.536 357.936 320.427 358.863 321.63 358.803C322.232 358.77 322.8 358.5 323.231 358.086C323.661 357.672 323.953 357.116 324.007 356.512L324.581 350.093C324.776 347.908 326.716 346.044 328.944 345.933C331.128 345.824 332.756 347.516 332.561 349.695L331.984 356.145C331.987 356.154 331.984 356.151 331.984 356.151L331.983 356.157C331.983 356.163 331.983 356.163 331.983 356.163C331.982 356.169 331.982 356.169 331.982 356.169L331.985 356.172C331.988 356.175 331.984 356.178 331.984 356.178C331.91 357.352 332.795 358.246 333.977 358.183C335.18 358.123 336.246 357.099 336.353 355.899L336.377 355.634C336.471 354.576 336.974 353.558 337.791 352.773C338.607 351.988 339.638 351.526 340.736 351.471C342.927 351.368 344.542 353.055 344.366 355.132L341.059 379.374C340.389 384.254 337.948 388.94 334.181 392.563C330.147 396.44 325.044 398.72 319.804 398.981Z"
                fill="#344A58"
            />
            <path
                d="M323.781 332.78C327.149 325.447 326.132 317.379 321.185 312.233C314.212 304.98 301.752 305.602 293.413 313.619C287.498 319.306 285.023 327.548 287.1 334.613C287.188 334.906 287.337 335.156 287.531 335.358C288.065 335.913 288.947 336.09 289.801 335.741C290.966 335.257 291.646 333.973 291.324 332.871C289.705 327.373 291.626 320.963 296.224 316.542C302.711 310.306 312.4 309.823 317.825 315.465C321.67 319.464 322.457 325.739 319.836 331.448C319.307 332.593 319.762 333.826 320.854 334.188C321.945 334.557 323.255 333.928 323.781 332.78Z"
                fill="#344A58"
            />
        </g>
    </svg>
)
    const SVGWheelWhite = (state) => (
        <svg
            className="selectGoalWheel__wheel"
            viewBox="0 0 440 440"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                transform: `rotate(${String(-51.42)}deg)`,
            }}
        >
            <defs>
                <g id="overlayW">
                    <rect
                        className="rectWheelShareWhite"
                        x="219"
                        y="20"
                        height="200"
                        width="10"
                    />
                </g>
            </defs>
            <mask id="wedge-mask" fill="white">
                <path
                    transform="translate(20, 20)"
                    d="M93 7.241a200.006 200.006 0 01200.551-.865L200.004 200 112.33 20.241z"
                    fillRule="nonzero"
                />
            </mask>
            {state.AllState.areas.map((item, i) => (
                <SliceStep2
                    key={i}
                    index={i}
                    Fs={item}
                    FullState={state.AllState}
                    allColors={true}
                />
            ))}
            <circle cx="220" cy="220" r="48" fill="White" strokeWidth="1" />
            <circle cx="220" cy="220" r="40" fill="#C9C9C9" strokeWidth="1" />
            <use xlinkHref="#overlayW" transform="rotate(56, 222, 220)" />
            <use xlinkHref="#overlayW" transform="rotate(107.13, 220, 220)" />
            <use xlinkHref="#overlayW" transform="rotate(159.55, 222, 220)" />
            <use xlinkHref="#overlayW" transform="rotate(209.97, 220, 223)" />
            <use xlinkHref="#overlayW" transform="rotate(262, 220, 222)" />
            <use xlinkHref="#overlayW" transform="rotate(310.91, 218, 223)" />
            <use xlinkHref="#overlayW" transform="rotate(364.23, 227, 208)" />
            <circle cx="220" cy="220" r="30" fill="white" strokeWidth="1" />
        </svg>
    );
    function changeModal(showx) {
        setShowModalWheel(showx);
    }
    const WheelR = (
        <>
            <div
                className="selectGoalWheel__container"
                style={{ height: '100%' }}
                onMouseEnter={() => {if(propsx.showColors!=true)setShowPop(true)}}
                onMouseLeave={() => {if(propsx.showColors!=true)setShowPop(false)}}
                onClick={() => {
                    changeModal(true);
                }}
            >
                {props.AllState.areas ? (!showPop?SVGWheel:SVGWheelColor) : <div />}
            </div>
            {showModalWheel === true && (
                <ModalOolaWheel
                    svgWheel={SVGWheelWhite(props)}
                    showModalWheel={showModalWheel}
                    setShowModalWheel={changeModal}
                    AllState={props}
                    currBadget={props.currBadget}
                />
            )}
        </>
    );

    return WheelR;
};
export default Wheel;
